import React from 'react';
import Row from './Row';
import { jsx as _jsx } from "react/jsx-runtime";
const AlternatingLayout = props => /*#__PURE__*/_jsx("section", {
  children: props.children
});
AlternatingLayout.Row = Row;
export default AlternatingLayout;